const brandingSettings = {
  default: {
    css: "./styles/variables.css",
    name: "sophyapp",
    imagePath: "/images/sophy_full_main_logo.jpg",
    title: "Therapeut sophyapp",
    icon: "/favicon.ico",
  },
  "medfit.ch": {
    css: "./styles/medfit.css",
    name: "medfit",
    imagePath: "/images/ci/medfit/medfit1.jpg",
    title: "Langfristig therapieren!",
    icon: "/images/ci/medfit/faviconV2.ico",
    portalUrl: "https://training.medfit.ch",
  },
  "therapeut.medaix-exercise.de": {
    css: "./styles/medaix.css",
    name: "medaix",
    imagePath: "/images/ci/medaix/medaix_logo.png",
    title: "Therapeut MedAix",
    icon: "/images/ci/medaix/favicon.ico",
    portalUrl: "https://medaix-exercise.de",
  },
  "therapiecentral.at": {
    css: "./styles/therapiecentral.css",
    name: "therapiecentral",
    imagePath: "/images/ci/therapie_central/TherapieCentral.jpg",
    title: "Therapie Central",
    icon: "/images/ci/therapie_central/favicon.ico",
    portalUrl: "https://app.therapiecentral.at",
  },
};

export function getBrandingSettings(hostname) {
  const key = Object.keys(brandingSettings).find((key) =>
    hostname.endsWith(key)
  );
  return brandingSettings[key] || brandingSettings.default;
}
